import React from 'react';
import { Tag } from 'antd';
import { MonitoringSchedule, MonitoringWindowType } from '@sonar-software/sonar-core';
const notificationFrequencyColors = {
    [MonitoringWindowType.Hourly]: 'orange',
    [MonitoringWindowType.Weekly]: 'green',
    [MonitoringWindowType.Monthly]: 'purple',
    [MonitoringWindowType.Daily]: 'cyan',
    [MonitoringSchedule.Immediately]: 'volcano'
};
export const NotificationFrequencyTag = ({ frequency }) => {
    var _a;
    if (!frequency) {
        return null;
    }
    const label = (_a = MonitoringWindowType[frequency]) !== null && _a !== void 0 ? _a : MonitoringSchedule[frequency];
    const color = notificationFrequencyColors[frequency];
    return React.createElement(Tag, { color: color }, label);
};
